/**
 * CreatedSchedule container logic selectors
 *
 * @author Rafael Guedes <rguedes@ubiwhere.com>
 *
 */

import { RootState } from 'store/rootSlices';

export const getRegistration = (state: RootState) => state.StudentRegistrationDropdown.registration;
export const getMySchedules = (state: RootState) => state.MySchedules.createdSchedules;
